import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-line bg-ink-800 py-16 md:py-24" aria-labelledby="faq-title" data-id="element-54" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto max-w-3xl px-5 md:px-8" data-id="element-55" data-mp="1geiiy4eo4av0">
        <h2 id="faq-title" className="font-display text-4xl font-extrabold uppercase text-white md:text-6xl" data-id="element-56" data-mp="2e0pr1oa6klc4">
          Frequently Asked Questions
        </h2>

        <ul className="mt-10 divide-y divide-line border-y border-line" data-id="element-57" data-mp="241qomng0dlxk">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-58" data-mp="sn3g8aizbrj8" data-mpi={index}>
                <h3 data-id="element-59" data-mp="so62u699r7tc">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-60" data-mp="soej884lov9a">
                    <span className="font-display text-lg font-bold uppercase tracking-wide text-white md:text-xl" data-id="element-61" data-mp="kil548nwvien">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-snap ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-62" data-mp="6plsqfjfe4bb" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-63" data-mp="1q95hton6v87">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-64" data-mp="3jyi02ur5gb4v">
                      <p className="pb-6 pr-8 text-sm leading-relaxed text-slate-300 md:text-base" data-id="element-65" data-mp="1krb64xc7qtyv">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}